import {TeamMemberTeamList} from "../models/Teams";

export const isLastManagerById = (
  members: TeamMemberTeamList[],
  id: string
): boolean => {
  const managers = members?.filter((member) => member?.role === "manager") || [];
  return managers?.length === 1 && managers?.[0]?.id === id;
};